import 'twin.macro';
import React from 'react';
import { Tag } from '@teetsh/app/src/components/Tag';
import { useField } from 'react-final-form';

interface Props {
  label: string;
  onClose: () => void;
}

export function FilterBadge(props: Props) {
  const { label, onClose } = props;
  const queryField = useField('query');
  return (
    <Tag
      outlined
      color="gris-supershy"
      tw="whitespace-nowrap"
      onClose={() => {
        onClose();
        queryField.input.onChange('');
      }}
    >
      {label}
    </Tag>
  );
}
